/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import { IProductListBlockData } from './product-list-block.data';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { ILinksData, IProductListBlockProps } from './product-list-block.props.autogenerated';
import classnames from 'classnames';

export interface IProductListBlockViewProps extends IProductListBlockProps<IProductListBlockData> {
    productImage?:React.ReactNode;
    productName?:React.ReactNode;
    productLink:ILinksData;
    className?:string;
    productBlockContainer:IModuleProps;
    imageContainer:INodeProps;
    detailsContainer:INodeProps;
    
}

/**
 *
 * ProductListBlock component
 * @extends {React.PureComponent<IProductListBlockProps<IProductListBlockData>>}
 */
class ProductListBlock extends React.PureComponent<IProductListBlockProps<IProductListBlockData>> {
    
    public render(): JSX.Element | null {
        const {
            productImage,
            productName,
            links,
            className
        }=this.props.config;
        const imageProps={
            gridSettings:this.props.context.request.gridSettings||{},
            imageSettings:productImage&&productImage.imageSettings,
        };
        const productImageBlock=productImage&&(
          <Msdyn365.Image {...productImage} {...imageProps} src={productImage.src+"&w=400"} />
        );
        const productNameBlock=productName&&(
            <Msdyn365.Text
                className='product-list-block__name'
                text={productName}
                tag={'h3'}
            />
        );

        if(
            !productImageBlock&&
            !productNameBlock
        ){
            this.props.context.telemetry.error(
                'Product List Block is empty, module wont render.'
              );
              return null;
        }

        const ProductListBlockViewProps={
            ...this.props,
            productImage: productImageBlock,
            productName:productNameBlock,
            moduleClass:this.props.config.className,
            productBlockContainer:{
                moduleProps:this.props,
                className:classnames('product-list-block',className),
            },
            imageContainer:{className:'product-list-block__image'},
            detailsContainer:{className:'product-list-block__details'},
            productLink:links
        }

        return this.props.renderView(ProductListBlockViewProps) as React.ReactElement;
    }
  
}

export default ProductListBlock;
